import { Permission } from './../../../models/permission.model';
import { PermsService } from './../../../services/utils/perms.service';
import { Observable } from 'rxjs/Rx';
import { LoyaltyClusterService } from './../../../services/loyalty/loyalty-cluster.service';
import { Component, OnInit } from '@angular/core';
import { CardDefinition } from '../../../models/loyalty-card-definition.model';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyCardDefinitionService } from '../../../services/loyalty/loyalty-card-definition.service';
import { Router } from '@angular/router';
import { Channel } from '../../../models/loyalty-channel.model';
import { Cluster } from '../../../models/loyalty-cluster.model';
import { LoyaltyChannelService } from '../../../services/loyalty/loyalty-channel.service';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-loyalty-card-definition',
  templateUrl: './loyalty-card-definition.component.html',
  styleUrls: ['./loyalty-card-definition.component.css']
})
export class LoyaltyCardDefinitionComponent implements OnInit {

  columsTitles: any;
  totalRecords = 0;
  showModalDelete: boolean;
  sortO: number;
  sortF: string;
  listCluster = new Array<{ value: string, label: string }>();
  listChannel = new Array<{ value: string, label: string }>();
  channels = new Map<string, Channel>();
  clusters = new Map<string, Cluster>();
  serverPagination = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  newDataAvailable = false;

  // Mostra tasti di edit, delete e recover
  cardDefPermission: Permission;

  listStates: Array<{value: string, label: string}>;
  render = {
    datatable: false
  };

  constructor(
    private translate: TranslateService,
    public cardDefService: LoyaltyCardDefinitionService,
    private router: Router,
    private channelService: LoyaltyChannelService,
    private clusterService: LoyaltyClusterService ,
    private srvPermission: PermsService
  ) { }

  ngOnInit() {
    this.listCluster = [];
    this.listChannel = [];

    this.sortO = 1;
    this.sortF = '';

    let ClusterList: Observable<any>;
    ClusterList =  this.clusterService.list();


    this.listCluster.push({
      label: "",
      value: null
    })


    const TRANSLATIONS = this.translate.get([
      'card_def.channel_id',
      'card_def.cluster_id',
      'card_def.description',
      'card_def.range_min',
      'card_def.range_max',
      'card_def.card_prefix',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended'
    ]);

    const PERMISSIONS = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'card_def'});


    Observable.zip(
      TRANSLATIONS,
      PERMISSIONS,
      ClusterList,

    ).subscribe(([resTranslation, resPermissions, resClusterList]) => {

    this.cardDefPermission = resPermissions;

    this.listStates = [];
    this.listStates.push({ label: resTranslation[''], value: null });
    this.listStates.push({ label: resTranslation['common.status_notDeleted'], value: '0' });
    this.listStates.push({ label: resTranslation['common.status_onlyDeleted'], value: '1' });

    this.columsTitles = {
      channel_id: resTranslation['card_def.channel_id'],
      cluster_id: resTranslation['card_def.cluster_id'],
      description:  resTranslation['card_def.description'],
      renge_min:  resTranslation['card_def.renge_min'],
      renge_max:  resTranslation['card_def.renge_max'],
      card_prefix:  resTranslation['card_def.card_prefix'],
    };

    for (const singleCluster of resClusterList.data) {
      this.listCluster.push({
        label: singleCluster.description,
        value: singleCluster.id
      });
    }

    this.render.datatable = true;

  });

  }
  edit(cardDefinition: CardDefinition) {
    this.router.navigate(['/loyalty/card_def/form', cardDefinition.id]);
  }

  addNew(event: any) {
    this.router.navigate(['/loyalty/card_def/form']);
  }

  remove(cardDef) {
    this.cardDefService.remove(cardDef.id).subscribe(() => {
      this.newDataAvailable = true;
    });
  }
  recover(cardDef){
    this.cardDefService.recover(cardDef).subscribe((res) => {
      this.newDataAvailable = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-definition/loyalty-card-definition.component.ts